import { Editor, Range, Transforms } from 'slate';
import { isLink, isLinkActive } from '../helpers';
import { LinkElement } from '../types';

export const insertLink = (editor: Editor, href: string): void => {
	if (!editor.selection) return;
	wrapLink(editor, href);
};

export const unwrapLink = (editor: Editor): void => {
	Transforms.unwrapNodes(editor, {
		match: isLink,
	});
};

// (Un-)wrap text as/insert link
export const wrapLink = (editor: Editor, href: string): void => {
	if (isLinkActive(editor)) {
		unwrapLink(editor);
	}

	const { selection } = editor;
	const isCollapsed = selection && Range.isCollapsed(selection);
	const link: LinkElement = {
		type: 'link',
		href,
		children: isCollapsed ? [{ text: href }] : [],
	};

	if (isCollapsed) {
		Transforms.insertNodes(editor, link);
	} else {
		Transforms.wrapNodes(editor, link, { split: true });
		Transforms.collapse(editor, { edge: 'end' });
	}
};
